import { computed, inject, Injectable, Injector, resource, signal } from '@angular/core';
import { handleRequestError } from '@softline/application';
import { RepositoryObjectService } from '@softline/core';
import { TaskRepository } from '../repositories/task.repository';
import { Task } from '../types/task';

@Injectable()
export class TaskService extends RepositoryObjectService<Task, Task, any, any> {
  protected override repository = inject(TaskRepository);
  private readonly injector = inject(Injector);

  constructor() {
    super(inject(TaskRepository), { skipInitialLoad: true });
  }

  readonly taskId = signal<number | null>(null);

  override params = computed<{ id: number }>(() => ({ id: this.taskId() ?? 0 }));

  getValue(result: Task): Task {
    return result ?? undefined;
  }

  readonly workflowId = signal<number | null>(null);

  private readonly taskResource = resource({
    params: () => this.workflowId(),
    loader: async ({ params }) => {
      if (params === null) return null;
      try {
        return await this.repository.getTaskByWorkflowId(params.toString());
      } catch (error) {
        handleRequestError(error, this.injector, { show: true });
        return null;
      }
    },
  });

  readonly task = this.taskResource.asReadonly();

  async patchTask(task: Task, params: { id: number }): Promise<Task> {
    const result = await this.repository.patch(task, params);
    this.taskResource.set(result);
    return result;
  }
}
